import base from '../dr-base'
import drIframe from './dr-iframe.vue'

const schema = {
  $Type: 'dr-iframe',
  name: 'Iframe',
  group: 'Advanced',
  icon: 'brackets-curly',
  ...base,
  properties: {
    ...base.properties,
    Src: {
      name: 'vuetifyWidgets.dr-iframe.src',
      type: 'string'
    },
    Height: {
      name: 'vuetifyWidgets.dr-iframe.height',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drIframe
}
